import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../styles/completeConfiguration.scss';
import { getURL } from '../../../../../redux/connectedComponent/provisionSettings/provisionSettings.slice';
import Overlay from '../../../../Overlay/Overlay';
import { Loader } from 'cdk-radial';

const COLOR_STROKE = 'rgba(21,27,37,0.4)';

const ConfigurationDialog = (props) => {

    const [showDialogSpinner, setShowDialogSpinner] = useState(false);

    const {urlParam, redirectURL, entityID, openDialog, setOpenDialog} = props;
    const dispatch = useDispatch();
    const state = useSelector(state => state);

    const constants = 
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.constants;

    const token = state && state.loginDetailsSlice && state.loginDetailsSlice.authenticationToken;


    return (
        <Overlay
        active={openDialog}
        title={`Complete Configuration`}
        hideFirstButton={true}
        secondButtonText={showDialogSpinner ? <Loader label='Loading' style={{stroke: COLOR_STROKE}}/> : 'Configure Now'}
        hideSecondButton={false}
        children={`You have confirmed your ${constants.ACTIVATION} but your configuration is pending`}
        onOverlayAccept={()=>{
            setShowDialogSpinner(true);
            if (entityID) {
                dispatch(getURL({url: redirectURL,type:'entityId', ids:urlParam, token}));
            } else{
                dispatch(getURL({url: redirectURL,type:'subscriptionId', ids:urlParam, token}));
            }
        }}
        disableSecondButton={showDialogSpinner}
        onOverlayClose={()=>setOpenDialog(false)}
      />
    );
}

export default ConfigurationDialog;